module.exports = __webpack_public_path__ + "media/components/utils/fonts/BellMTStd-Bold-e5da5c7b6d03575b0dba2832ba6300ee.otf";